import { ScreeningQuestionCycledOutReason } from '@scale/shared-types';

export const ARCHIVED_REASON_DISPLAY = {
  [ScreeningQuestionCycledOutReason.TooHard]: 'Too Hard',
  [ScreeningQuestionCycledOutReason.TooEasy]: 'Too Easy',
  [ScreeningQuestionCycledOutReason.BadQuality]: 'Bad Quality',
  [ScreeningQuestionCycledOutReason.TooSimilar]: 'Too Similar',
  [ScreeningQuestionCycledOutReason.NotEnoughTime]: 'Not Enough Time',
  [ScreeningQuestionCycledOutReason.WordCountTooLow]: 'Word Count Too Low',
  [ScreeningQuestionCycledOutReason.Other]: 'Other',
};

export enum ScreeningCenterListTab {
  Start = 'start',
  ScreeningConfig = 'config',
  ScreeningReview = 'ats',
  QuestionBank = 'bank',
  QuestionBankAdmin = 'bank-admin',
}

export const SCREENING_CENTER_TABS = [
  {
    id: ScreeningCenterListTab.Start,
    label: 'Start Here',
  },
  {
    id: ScreeningCenterListTab.ScreeningConfig,
    label: 'Assessments',
  },
  {
    id: ScreeningCenterListTab.ScreeningReview,
    label: 'Assessment Review',
  },
  {
    id: ScreeningCenterListTab.QuestionBank,
    label: 'Questions',
  },
];

export const SCREENING_CENTER_ADMIN_TABS = [
  ...SCREENING_CENTER_TABS,
  {
    id: ScreeningCenterListTab.QuestionBankAdmin,
    label: '[Admin] Question Banks',
  },
];

export enum Routes {
  ScreeningCenter = '/genai-ops-hub/screening-center',
  ScreeningConfigSetup = '/genai-ops-hub/screening-center/config',
  ScreeningCenterAssessmentReview = '/genai-ops-hub/screening-center/ats',
  QuestionSetup = '/genai-ops-hub/screening-center/bank/question',
  QuestionBankAdminSetup = '/genai-ops-hub/screening-center/bank-admin',
}
